const situations = [
  { icon: 'ri-history-line', text: 'Сотрудники работают по старым подходам и не осваивают новые инструменты' },
  { icon: 'ri-user-add-line', text: 'Новые сотрудники долго выходят на самостоятельную работу' },
  { icon: 'ri-parent-line', text: 'Руководители постоянно обучают подчинённых вместо того, чтобы управлять' },
  { icon: 'ri-user-star-line', text: 'Компания зависит от отдельных сильных специалистов' },
  { icon: 'ri-chat-off-line', text: 'Опыт сотрудников не передаётся внутри команды' },
  { icon: 'ri-vip-crown-line', text: 'Нет понятного кадрового резерва и плана подготовки будущих руководителей' },
  { icon: 'ri-question-line', text: 'Сотрудники не понимают, какие компетенции им необходимо развивать' },
  { icon: 'ri-link-unlink', text: 'Обучение проводится отдельно от задач бизнеса' },
  { icon: 'ri-refresh-line', text: 'После тренингов сотрудники возвращаются к прежним привычкам' },
  { icon: 'ri-speed-mini-line', text: 'Руководители не понимают, как оценивать развитие сотрудников' },
  { icon: 'ri-user-unfollow-line', text: 'Перспективные сотрудники уходят, потому что не видят возможностей роста' },
];

export default function WhyDevelopmentNeeded() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что происходит, когда развитием персонала не занимаются системно
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Это не катастрофа и не обвинение. Это типичные ситуации, которые возникают в компаниях, где обучение есть, а системы развития — нет. Узнаёте свою компанию в одном или нескольких пунктах?
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${s.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-base md:text-lg font-medium text-gray-800 mt-10 max-w-3xl mx-auto leading-relaxed">
          Все эти ситуации объединяет одно: развитие происходит стихийно, а не как система, связанная с задачами бизнеса.
        </p>
      </div>
    </section>
  );
}